module.exports = __webpack_public_path__ + "img/back-md.28a66165.png";